
    import { TTableProps } from "../types/TableView";
    import TableView from "../components/TableView";

  const RetatilerdataList = ({ columns, rows, showPagination, showSearch, showPerPage, paginationData, onPageChange, onPerPageChange, handleSearchParams, searchPlaceholder }:TTableProps) => { 
   return (
    
    <TableView
    columns={columns}
    rows={rows}
    showPagination={showPagination}
    showSearch={showSearch}
    showPerPage={showPerPage}
    paginationData={paginationData}
    onPageChange={onPageChange}
    onPerPageChange={onPerPageChange}
    handleSearchParams={handleSearchParams}
    searchPlaceholder={searchPlaceholder}
  />
    
  );
};

export default RetatilerdataList;
    